import LegalPageLayout from "../common/LegalPageLayout";

// Content lives in locales/{es,en,de}/translation.json under "legal_pages.terms_conditions".
// See LegalPageLayout.js for the expected shape and how to edit/extend it.
const TermsConditions = () => <LegalPageLayout translationKey="legal_pages.terms_conditions" />;

export default TermsConditions;
